describe("example", () => {
    it("must be always true", () => {
        expect(true).toBe(true);
    });
});
